import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Modal, Row, Col, /* Image, */ Button, Alert } from 'react-bootstrap'
import InputPassword from '../../commons/form/InputPassword'
import InputPasswordStrengthIndicator from '../../commons/form/InputPasswordStrengthIndicator'
import { isValidPassword, passwordHasMinCriteria } from '../../../components/access/validation/validatePassword'

class ModalChangePassword extends PureComponent {
  onSubmit (values) {
    return new Promise((resolve, reject) => {
      this.props.actions.changePassword(
        values,
        this.props.t,
        (result) => {
          resolve(result)
        },
        reject,
        this.props.tokenId
      )
    })
  }

  componentDidMount () {
    const { tokenId, actions } = this.props
    if (tokenId) actions.checkToken(tokenId)
    actions.fetchPasswordPolicy()
  }

  render () {
    const {
      t, handleSubmit, error, invalid,
      emailAddress, passwordPolicy, showChangePasswordModal,
      formValues, formErrors
    } = this.props
    const tKey = 'RESET_PASSWORD.'

    return (
      <Modal
        id='modalChangePassword'
        className="modal-change-password _nf"
        show={showChangePasswordModal}
        backdrop="static"
        keyboard={false}
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title className="title center">
            <span dangerouslySetInnerHTML={{ __html: t(`${tKey}CHANGE_PASSWORD`) }}></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="change-password" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            {emailAddress && (
              <Row>
                <Field
                  t={t}
                  colSm={10}
                  colSmOffset={1}
                  id='modalChangePassword_oldPassword'
                  name='oldPassword'
                  placeholder={t(tKey + 'OLD_PASSWORD')}
                  controlLabel={t(tKey + 'OLD_PASSWORD')}
                  component={InputPassword}
                />
                <Field
                  t={t}
                  colSm={10}
                  colSmOffset={1}
                  id='modalChangePassword_newPassword'
                  name='newPassword'
                  placeholder={t(tKey + 'NEW_PASSWORD')}
                  controlLabel={t(tKey + 'NEW_PASSWORD')}
                  component={InputPassword}
                />
                <InputPasswordStrengthIndicator
                  t={t}
                  colSm={10}
                  colSmOffset={1}
                  id='modalChangePassword_passwordStrengthIndicator'
                  name='passwordStrengthIndicator'
                  passwordPolicy={passwordPolicy}
                  passwordValue={formValues && formValues.newPassword ? formValues.newPassword : ''}
                  passwordError={formErrors && formErrors.newPassword ? formErrors.newPassword : false}
                />
                <Field
                  t={t}
                  colSm={10}
                  colSmOffset={1}
                  id='modalChangePassword_pwdLoginRepeat'
                  name='pwdLoginRepeat'
                  placeholder={t(tKey + 'REPEAT_PASSWORD')}
                  controlLabel={t(tKey + 'REPEAT_PASSWORD')}
                  component={InputPassword}
                />
                <div className='flexInLine al-C'>
                  <Button
                    id='modalChangePassword_btn_change'
                    type='submit'
                    // bsStyle='primary'
                    className='_Btn accept'
                    name='btn-change-password-auth'
                    disabled={invalid}
                  >{t(tKey + 'CHANGE')}
                  </Button>
                </div>

                {error && (
                  <Col smOffset={1} sm={10}>
                    <Alert bsStyle='danger' role='alert'>
                      <strong>{t('ERRORS.SERVER_ERROR')}</strong>
                      <p>{error}</p>
                    </Alert>
                  </Col>
                )}
              </Row>
            )}
            {!emailAddress && (
              <div>
                <Col smOffset={1} sm={10}>
                  <Alert bsStyle='warning' role='warning'>
                    <strong>{t(tKey + 'TOKEN_NOT_VALID')}</strong>
                  </Alert>
                </Col>
              </div>
            )}
            <div className="poweredByWrapper">
              <div className='logoPoweredBy'></div>
              {/* <Image src="images/poweredby.png" /> */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    )
  }
}

function modalChangePassword (values, props) {
  const errors = {}
  const { oldPassword, newPassword, pwdLoginRepeat } = values
  const { t, passwordPolicy, emailAddress, userName, userSurnames } = props

  if (!oldPassword) errors.oldPassword = t('GLOBAL.FORMS.REQUIRED')
  if (!newPassword) errors.newPassword = t('GLOBAL.FORMS.REQUIRED')
  if (!pwdLoginRepeat) errors.pwdLoginRepeat = t('GLOBAL.FORMS.REQUIRED')

  if (newPassword && pwdLoginRepeat && newPassword !== pwdLoginRepeat) {
    errors.pwdLoginRepeat = t('RESET_PASSWORD.NEW_PASSWORD_EQUAL')
  }

  if (newPassword) {
    if (passwordHasMinCriteria(newPassword, passwordPolicy.minNumberOfCriteria)) {
      errors.newPassword = t('RESET_PASSWORD.MUST_CONTAIN_X_POLICIES').replace('##NUMBER##', passwordPolicy.minNumberOfCriteria)
    } else if (newPassword.length < passwordPolicy.minNumberOfCharactersInPassword) {
      errors.newPassword = t('RESET_PASSWORD.MUST_CONTAIN_X_CHARACTERS').replace('##NUMBER##', passwordPolicy.minNumberOfCharactersInPassword)
    } else if (
      emailAddress &&
      (
        !isValidPassword(emailAddress, newPassword, passwordPolicy.maxNumberOfOtherAttributeCharsContainedInPassword) ||
        !isValidPassword(userName, newPassword, passwordPolicy.maxNumberOfOtherAttributeCharsContainedInPassword) ||
        !isValidPassword(userSurnames, newPassword, passwordPolicy.maxNumberOfOtherAttributeCharsContainedInPassword)
      )
    ) {
      errors.newPassword = t('RESET_PASSWORD.PASSWORD_CONTAINS_NAME').replace('##NUMBER##', passwordPolicy.maxNumberOfOtherAttributeCharsContainedInPassword)
    }
  }

  return errors
}

export default reduxForm({
  form: 'modalChangePassword',
  validate: modalChangePassword
})(ModalChangePassword)
